module.exports = __webpack_public_path__ + "files/b9406f17bcbb528bb5c6551bc0effcbf.png";